<template>
    <div>
        <div v-if="joinMinDate">
            <button v-if="!joinDates" @click="joinDatesClick" class="btn c-btn-summary join-dates">
                Unificar fechas de entrega
            </button>
            <div v-else class="join-date">
                <button type="button" class="close ml-auto mb-1" @click="joinDates = false">×</button>
                <h5>Unificar fechas de entrega</h5>
                <p>Selecciona entre la fecha más temprana posible o escoge otra fecha</p>
                <b-button class="btn" variant="outline-light" @click="clickDateOffer">
                    {{ moment(this.joinMinDate).format('dddd D [de] MMMM YYYY') }}
                </b-button>
                <b-button class="btn" variant="outline-light" style="margin-top: 0.5em" @click="clickOtherDate">
                    Escoger otra fecha
                </b-button>
            </div>
        </div>
        <b-modal v-model="otherDate" modal-class="c-join-dates" @ok="okButton" ok-title="Unificar" cancel-title="Cancelar" title="Unificar fechas" centered>
            <custom-date-picker v-model="date" :block-to="joinMinDateBlock"></custom-date-picker>
        </b-modal>
    </div>
</template>

<script>
import CustomDatePicker from "./CustomDatePicker";
export default {
    name: "JoinDates",
    components: {CustomDatePicker},
    props: {
        joinMinDate: {
            type: Date
        }
    },
    data() {
        return {
            joinDates: false,
            date: null,
            otherDate: false,
            saving: false,
            moment
        }
    },
    computed: {
        joinMinDateBlock() {
            // Fix to avoid block actual day
            return moment(this.joinMinDate).subtract(1, 'day').toDate();
        }
    },
    methods: {
        joinDatesClick() {
            this.joinDates = true;
        },
        clickDateOffer() {
            this.save(this.joinMinDate);
        },
        clickOtherDate() {
            this.otherDate = true;
        },
        okButton() {
            this.save(this.date);
        },
        save(date) {
            let formData = new FormData();
            formData.append('join_dates', 1);
            formData.append('date', moment(date).format('YYYY-MM-DD'));
            this.saving = true;
            axios.post(this.route('custom.summary-next'), formData).then((response) => {
                this.$emit('dates-joined', date);
            }).catch(e => {
                Vue.toasted.error("Error al enviar los datos al servidor", {
                    duration: 3000
                });
            }).finally(() => {
                this.saving = false;
            });
        }
    }
}
</script>

<style scoped>
.c-btn-summary {
    font-size: 17px;
    width: 100%;
    font-weight: bold;
    padding: 5px;
    margin-top: 10px;
    border-width: 2px;
    border-radius: 0;
    margin-bottom: 0.5em;
    max-width: 250px;
}

.c-btn-summary.join-dates {
    color: #0a71b8;
    border-color: #0a71b8;
    font-size: 1.2em;
}

.c-btn-summary.join-dates:hover {
    background-color: #0a71b8;
    color: #fff;
}

.join-date {
    background-color: #0871b8;
    color: white;
    padding: 1em;
}

.join-date .btn {
    display: block;
    margin: auto;
    font-weight: bold;
    border-width: 0.15em;
    width: 100%;
    max-width: 260px;
}

.join-date button.close {
    color: #fff;
    opacity: 1;
}

</style>

<style>
.c-join-dates .modal-header {
    background: #0871b8;
    color: white;
    border-radius: 0;
    padding: 0.5rem 1rem;
}

.c-join-dates .modal-body {
    overflow-x: hidden;
}

.c-join-dates .modal-header .close {
    color: white;
    text-shadow: none;
    opacity: 1;
}

.c-join-dates .modal-footer {
    justify-content: center;
}

.c-join-dates .modal-footer .btn {
    padding: 0.175rem 2rem;
}

.c-join-dates .modal-footer .ok-btn {
    background-color: #0871b8;
}
</style>
